<template>
	<div v-show="show" style="width: 100%;">
		
		<el-table  
		
			:style="tableStyle"
			:id="tableId"  
			:data="list" 
			:height="currentHeight"
			:header-cell-style="cellstyle"
			:row-style="rowstyle" 
			@row-click="toDetails"
			@selection-change="handleSelectionChange"
			ref="multipleTable" 
			>
			<slot name="body"></slot>
			<template slot="empty">
				<div class="empty_box FlexColumn"> 
					<img src="https://scrm.51kuaiding.com/scrm/hktxcx/bulletinboard/empty_img.png" alt="">
					<div class="empty_tit">
						没有相关数据哦～
					</div>
				</div>
			</template>
		</el-table>
		<!--  -->
		<template v-if="list">
			<div class="table_bottom FlexR_between " :style="botClass" v-show="list.length != 0">
				<!--  -->
				<div class="tleft Flex_align">
					<!--  -->
					<div class="t_checkbox" v-if="ischecks">
						<el-checkbox
						:indeterminate="isIndeterminate" 
						v-model="allchecked" 
						@change="fn_checkAll"
						></el-checkbox>
					</div>
					<!--  -->
					<slot name="tabtns"></slot>
				</div>
				<!--  -->
				<!--  -->
				<div class="tright Flex_align" >
					<template v-if="ispagin">
						<el-pagination background layout="total,sizes, prev, pager, next" prev-text="上一页"
							next-text="下一页" :page-sizes="pagesizes" :page-size.sync="tab_pagesize" :current-page.sync="tab_page"
							:pager-count='5' :total="tab_total" @size-change="type_modify_page" @current-change="type_switch_page">
						</el-pagination> 
					</template>
				</div>
				<!--  -->
			</div>
		</template>
		<!--  -->
		
	</div>
</template>

<script>
	export default {
		name: "tabcontainer",
		props: {
			 
			tableId: {
				type: String,
				default: 'exportTab',
			},
			botClass: {
				type: String,
				default: 'padding: 10px 0',
			},
			tableStyle: {
				type: String,
				default: 'width: 99%;margin: 0 auto;',
			},
			
			// 是否显示
			show: {
				type: Boolean,
				default: true,
			},
			// 是否多选
			ischecks: {
				type: Boolean,
				default: true,
			},
			// 是否显示分页
			ispagin: {
				type: Boolean,
				default: true,
			},
			// 
			 
			// 页码 
			pagesize: {
				type: Number,
				default: 20,
			},
			page: {
				type: Number,
				default: 1,
			},
			total: {
				type: Number,
				default: 0,
			},
			// 
			// 表格高度
			surplus: {
				type: Number,
				default: 0,
			},
			pagesizes: {
				type: Array,
				default: ()=>{
					return [10, 20, 50, 100]
				},
			},
			 
			// 表格数据
			list: {
				type: Array,
				default: ()=>{
					return []
				},
			},
			
			// 表格样式
			cellstyle: {
				type: Object,
				default: ()=>{
					return {
						background: 'rgb(249,249,249)'
					}
				},
			},
			rowstyle: {
				type: Object,
				default: ()=>{
					return {
						height: '60px',
					}
				},
			},
		},
		data() {
			return {
				check_list: [],
				currentHeight: 'auto',
				// 全选
				allchecked: false,
				isIndeterminate: false,
				
				tab_pagesize: 20,
				tab_page: 1,
				tab_total: 0,
			}
		},
		created() {
			if(this.surplus) {
				this.currentHeight = this.surplus
			}
		},
		watch: {
			pagesize() {
				this.tab_pagesize = this.pagesize
			},
			page() {
				this.tab_page = this.page
			},
			total() {
				this.tab_total = this.total
			},
			// 表格高度
			surplus(){
				this.currentHeight = this.surplus
			},
			// 多选框
			check_list() {
				if(this.list) {
					let len1 = this.check_list.length
					let len2 = this.list.length
					if (len2 === len1) {
						this.isIndeterminate = false
						this.allchecked = true
					} else {
						this.allchecked = false
						this.isIndeterminate = true
					}
					if (len1 == 0) {
						this.allchecked = false
						this.isIndeterminate = false
					}
				}
			},
		},
		methods: {
			
			// 底部全选
			fn_checkAll(e) {
				if (this.allchecked === true) {
				  this.$refs.multipleTable.toggleAllSelection();
				} else {
				  this.$refs.multipleTable.clearSelection();
				}
			},
			
			// 勾选表格
			handleSelectionChange(val) {
				this.check_list = val
				this.$emit('retucheck', {val})
			},
			
			// 点击表格某一行 
			toDetails(row){
				this.$emit('returow', {row})
			},
			
			// 切换页码
			type_modify_page(val) {  // pagesize 
				this.$emit('changesize', {val})
			},
			type_switch_page(val) {  // page
				this.$emit('changepage', {val})
			},
		// methids end
		}
	}
</script>

<style scoped lang="scss">
	@import "@/assets/css/public.scss";
	.empty_box{
		img{
			width: 145px;
		}
		.empty_tit{
			color: rgba(0,0,0,.65);
			font-size: 13px;
		}
	}
	 
</style>
